export const ALERTS_PAGE_LIMIT = 10;